import {
  GeoEventSlackChannel,
  GeoEventSlackChannelType,
} from 'features/geoEvents/hooks/useGeoEventSlackChannels';

const channelTypeLabelKeys: Record<
  Exclude<GeoEventSlackChannelType, 'incident' | 'region'>,
  string
> = {
  parent_incident: 'geoEvent.slackChannels.types.parentIncident',
  prescribed_fire: 'geoEvent.slackChannels.types.prescribedFire',
  ring_photos: 'geoEvent.slackChannels.types.ringPhotos',
  photo_moderation: 'geoEvent.slackChannels.types.photoModeration',
};

const geoEventTypeLabelKeys: Record<
  GeoEventSlackChannel['geoEventType'],
  string
> = {
  wildfire: 'geoEvent.slackChannels.types.wildfire',
  flooding: 'geoEvent.slackChannels.types.flooding',
};

// Incident and region channels are labeled by the incident type they serve
export const getSlackChannelLabelKey = (
  channel: GeoEventSlackChannel,
): string =>
  channel.type === 'incident' || channel.type === 'region'
    ? geoEventTypeLabelKeys[channel.geoEventType]
    : channelTypeLabelKeys[channel.type];
